export default "__VITE_ASSET__DliViUZt__"